import { styled } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledManageSignalsPageContainer = styled(Stack)`
    ${integrationMaxWidth};
`;

export const approvalModalConfig = {
    content: {
        padding: "20px 24px 24px 24px",
        width: "550px",
    },
};

export const dataAgreementsModalConfig = {
    content: {
        padding: "45px 70px 45px 70px",
        width: "640px",
    },
};
